import api from './api'

// A base do axios já inclui /api — por isso os paths NÃO levam /api (senão vira /api/api/...).
export const sessionsApi = {
  getActive: () => api.get('/sessions/active').then((r) => r.data),
  terminate: (sessionId) => api.delete(`/sessions/${sessionId}`).then((r) => r.data),
}
